import '../Assets/css/banner.css';

export const Banner = () => {
    return (
        <div className="banner">
            <div className="banner-container">
                <p className="banner-text">
                    Tu opción más
                    conveniente,
                    segura y
                    confiable
                </p>
            </div>
        </div>
    )
}